import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;

  opacity: ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled ? '0.3' : '1';
}};
`;
export const StuntDouble = styled.button`
  background-color: transparent;
  border-radius: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size === 'sm' ? '2px' : size === 'md' ? '3px' : '4px';
}};
  border: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return `2px solid ${theme.colors.secondaryL2}`;
}};
  cursor: pointer;
  height: ${_ref4 => {
  let {
    size
  } = _ref4;
  return size === 'sm' ? '16px' : size === 'md' ? '21px' : '26.5px';
}};
  width: ${_ref5 => {
  let {
    size
  } = _ref5;
  return size === 'sm' ? '16px' : size === 'md' ? '21px' : '26.5px';
}};
  margin: ${_ref6 => {
  let {
    size
  } = _ref6;
  return size === 'sm' ? '4px' : size === 'md' ? '5px' : '6.5px';
}};
  position: relative;
  cursor: ${_ref7 => {
  let {
    disabled
  } = _ref7;
  return disabled ? 'not-allowed' : 'pointer';
}};

  /* Conversado com Will e Lany em manter o mesmo estilo para status focus e hover */
  &:not(:disabled):hover::after,
  &:not(:disabled):focus::after {
    content: '';
    position: absolute;
    height: 170%;
    width: 170%;
    top: -35%;
    left: ${_ref8 => {
  let {
    size
  } = _ref8;
  return size === 'md' ? '-34.5%' : '-35%';
}};
    border-radius: 50%;
    background-color: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return `${theme.colors.primaryL2}20`;
}};
  }

  &:focus {
    outline: none;
  }
`;
export const Label = styled.label`
  ${_ref10 => {
  let {
    theme,
    size
  } = _ref10;
  return size === 'sm' ? theme.fonts.infoSM : theme.fonts.infoMD;
}};
  color: ${_ref11 => {
  let {
    theme
  } = _ref11;
  return theme.colors.neutralL5;
}};
  cursor: ${_ref12 => {
  let {
    disabled
  } = _ref12;
  return disabled ? 'not-allowed' : 'pointer';
}};
  margin-left: 4px;
`;
export const Input = styled.input`
  display: none;

  &:checked + ${StuntDouble} {
    background: url('assets/check.svg') center/100% no-repeat;

    border-color: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.colors.primaryL1;
}};
    background-color: ${_ref14 => {
  let {
    theme
  } = _ref14;
  return theme.colors.primaryL1;
}};
  }
`;